import React from "react";
import { useTranslation } from "react-i18next";
import Modal from "components/Modal";
import Button from "components/Button";
import { IconClose } from "icons";
import CreditShortfallInfo from "./CreditShortfallInfo";

interface MemberCreditLimitModalProps {
  onClose: () => void;
  requiredCredits?: number | null;
  remainingCredits?: number | null;
}

// REF-5549 (BE REF-5446): a team member hit the per-member credit cap set by their admin. The
// member can't fix this themselves (only the admin can raise the cap), so there is NO upgrade CTA
// — just the shortfall numbers (reused from REF-5453) and a dismiss button.
const MemberCreditLimitModal: React.FC<MemberCreditLimitModalProps> = ({ onClose, requiredCredits = null, remainingCredits = null }) => {
  const { t } = useTranslation();

  return (
    <Modal onClose={onClose} show={true} bodyClassName="!border !border-grey-light bg-trueWhite !max-w-[480px] !w-full p-5" className="!z-[99999]" backdropDisabled={true}>
      <div className="relative flex flex-col items-center gap-6 w-full">
        <div className="cursor-pointer absolute top-0 right-0 w-fit bg-grey-light rounded-full p-0.5" onClick={onClose}>
          <IconClose />
        </div>

        <div className="flex flex-col items-center gap-2.5 mt-4">
          <h3 className="text-h3 text-center dark:text-white">{t("billing:member_credit_limit.title")}</h3>
          <span className="text-bodyMd text-center text-grey">{t("billing:member_credit_limit.description")}</span>
        </div>

        <CreditShortfallInfo requiredCredits={requiredCredits} remainingCredits={remainingCredits} />

        <Button className="btn-primary w-full" onClick={onClose}>
          {t("billing:member_credit_limit.cta")}
        </Button>
      </div>
    </Modal>
  );
};

export default MemberCreditLimitModal;
